import React from 'react';
import { Grid } from '@nextiva/next-ui-components';
import PropTypes from 'prop-types';

import { Snackbar } from 'components/Snackbar';
import cloneSVG from 'icons/clone.svg';
import xClose from 'icons/xClose.svg';

const DrawerHeader = ({ title, cloneIcon, closeDrawer, TitleComponent }) => {
  return (
    <div data-test-id="drawerHeader" className="m-chime-drawer__header">
      <Grid container spacing={2} alignItems="center">
        <Grid container item md={10} xs={8}>
          {title}
          {TitleComponent && <TitleComponent />}
        </Grid>
        <Grid item md={1} xs={2} align="right">
          {cloneIcon && (
            <img alt="clone" src={cloneSVG} className="drawerCloneIcon" />
          )}
        </Grid>
        <Grid item md={1} xs={2} align="right">
          <img
            alt="close"
            src={xClose}
            className="xClose"
            onClick={closeDrawer}
            role="presentation"
            data-testid="PlatformAdminUI-DrawerHeader-Close"
          />
        </Grid>
      </Grid>
      <Snackbar isDrawer />
    </div>
  );
};

DrawerHeader.propTypes = {
  TitleComponent: PropTypes.bool,
  cloneIcon: PropTypes.bool,
  closeDrawer: PropTypes.func,
  title: PropTypes.string,
};

DrawerHeader.defaultProps = {
  TitleComponent: false,
  cloneIcon: false,
  closeDrawer: () => {},
  title: '',
};

export default DrawerHeader;
